'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_ListElement$package$Person2$1(id, name, age) {
  this.sD = 0;
  this.sE = null;
  this.sC = 0;
  this.sD = id;
  this.sE = name;
  this.sC = age;
}
export { $c_Lsamples_ListElement$package$Person2$1 as $c_Lsamples_ListElement$package$Person2$1 };
$p = $c_Lsamples_ListElement$package$Person2$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_ListElement$package$Person2$1;
/** @constructor */
function $h_Lsamples_ListElement$package$Person2$1() {
}
export { $h_Lsamples_ListElement$package$Person2$1 as $h_Lsamples_ListElement$package$Person2$1 };
$h_Lsamples_ListElement$package$Person2$1.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  var acc = (-889275714);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, 986212189);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, this.sD);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sE));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, this.sC);
  return $j_java$002elang$002e$002dObject.$m_sr_Statics$().an(acc, 3);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsamples_ListElement$package$Person2$1) && (((this.sD === x$0.sD) && (this.sC === x$0.sC)) && (this.sE === x$0.sE))));
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 3;
});
$p.o = (function() {
  return "Person2";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.sD;
      break;
    }
    case 1: {
      return this.sE;
      break;
    }
    case 2: {
      return this.sC;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lsamples_ListElement$package$Person2$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eh)));
}
export { $isArrayOf_Lsamples_ListElement$package$Person2$1 as $isArrayOf_Lsamples_ListElement$package$Person2$1 };
var $d_Lsamples_ListElement$package$Person2$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_ListElement$package$Person2$1, "samples.ListElement$package$Person2$1", ({
  eh: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lsamples_ListElement$package$Person2$1 as $d_Lsamples_ListElement$package$Person2$1 };
